import styled from 'styled-components'

export const Container = styled.div`
  padding: ${props => props.theme.spacing.sp12} ${props => props.theme.spacing.sp12} 0px
    ${props => props.theme.spacing.sp12};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
